import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useNavigate } from "react-router";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { DialogBarNew } from "../../../components/common/DialogBarNew";

const dialogues = {
	dialagueOne:
		"¡Hola, [nombre]! Soy Datti Andati, tu compañero guía durante este curso. Estoy aquí para ayudarte en todo lo que necesites y asegurarme de que tengas una experiencia increíble",
	dialagueTwo:
		"A lo largo de este curso, estaré a tu lado para ofrecerte apoyo, resolver tus dudas, y proporcionarte la información que necesites. Puedes contar conmigo en cada paso del camino. ¡Vamos a hacer de este curso algo asombroso!",
};

export const SubtopicOne = () => {
	const { loaded } = useSelector((state) => state.menu);
	const [dialogVisible, setDialogVisible] = useState(true);
	const [dialogSelected, setDialogSelected] = useState(dialogues.dialagueOne);
	const navigator = useNavigate();

	useEffect(() => {
		if (loaded) {
			console.log("mounted subtema one introduction");
			ObserverEmitter.emit(EVENTS.subtopicOne.initScene, 0);
			ObserverEmitter.on(EVENTS.subtopicOne.introduction.initDialog, () => {
				setDialogVisible(true);
			});
		}
	}, [loaded]);

	const changeDialog = () => {
		if (dialogSelected === dialogues.dialagueOne) {
			setDialogSelected(dialogues.dialagueTwo);
		} else {
			navigator("/tema1/subtema1/activityone");
		}
	};

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
			</>
			{dialogVisible && (
				<>
					<DialogBarNew
						titulo="Andatti"
						dialog={dialogSelected}
						callback={changeDialog}
						percentage={dialogSelected === dialogues.dialagueOne ? "50%" : "99%"}
					/>
				</>
			)}
		</>
	);
};
